import { Erc20__factory } from '@/contracts';
import { CONSTANT } from '@/store/constants';

import { sharedProvider } from '@/store/provider';
import { useAddress } from '@/store/selector';
import useSWR from 'swr';

async function fetchBalance({ address }: { address: string }) {
  if (!address) {
    return undefined;
  }
  const provider = sharedProvider.get(CONSTANT.RPC_WLD);

  const contract = Erc20__factory.connect(CONSTANT.TOKEN_WLD, provider);
  const balance = await contract.balanceOf(address);

  return balance;
}

export function useBalance() {
  const address = useAddress();

  const data = useSWR({ key: 'fetch-balance', address }, fetchBalance, {
    dedupingInterval: 2000,
  });

  return { ...data, address };
}
